// extracted by mini-css-extract-plugin
module.exports = {"container":"main-analytics_container__oo9rL","mobileLink":"main-analytics_mobileLink__cq4H1"};